import React                     from 'react'
import loadable                  from '@loadable/component';
import { type } from 'jquery';

/* Components */
const ReportWrapper                 = loadable(() => import('../Components/Reports'));
const Wrapper                       = loadable(() => import('../Components/Wrapper'));
const Home                          = loadable(() => import('../Components/Home'));
const CollectionManagers            = loadable(() => import('../Components/CollectionManagers'));
const CobranzaAvanceRecuperacion    = loadable(() => import('../Components/Indicadores/cobranza/avance_recuperacion'));
const CobranzaAcumuladoRecuperacion = loadable(() => import('../Components/Indicadores/cobranza/acumulado_recuperacion'));
const Dashboards                    = loadable(() => import('../Components/Indicadores/listgeneral'))
const DashCarteraBuckets            = loadable(() => import('../Components/Indicadores/listcartera/cartera_buckets'));
const Rankings                      = loadable(() => import('../Components/Indicadores/rankings'));
const Pomelo                        = loadable(() => import('../Components/Pomelo'));
const Zonificacion                  = loadable(() => import('../Components/Indicadores/zonificacion'));
const ZonificacionMap               = loadable(() => import('../Components/Indicadores/zonificationMap'));
const Comparativos                  = loadable(() => import('../Components/Indicadores/comparativos'));
const Geolocation                   = loadable(() => import('../Components/Geolocation'));
const MetaCard                      = loadable(() => import('../Components/Metacard'));
const ValidacionCliente             = loadable(() => import('../Components/validacion-cliente'));
const OrdenesPago                   = loadable(() => import('../Components/OrdenesPago'))
const Expedientes                   = loadable(() => import('../Components/Expedientes/components/expedientes/GestionExpedientes'))
const MainContainer                 = loadable(() => import('../Components/MainContainer'))
const Login                         = loadable(() => import('../Components/Login'));
const Logout                        = loadable(() => import('../Components/Logout'));
const PageNotFound                  = loadable(() => import('../Components/pages/notFound'))


const AppRoutes = [
  {
    path:    "/:view/:idEmpleado",
    element: <Wrapper />,
    type:    "public"
  },
  {
    path:    "/:view/:typeReport/:idEmpleado",
    element: <ReportWrapper />,
    type:    "public"
  },
  {
    path:    "/cobranza-gestores/:idEmpleado",
    element: <CollectionManagers />,
    type:    "public"
  },
  {
    path:    "/app-geolocation/:idEmpleado",
    element: <Geolocation />,
    type:    "public"
  },
  {
    path:    "/assign-card/:idEmpleado",
    element: <MetaCard />,
    type:    "public"
  },
  {
    path:    "/",
    element: <Home />,
    type: "public",
  },
  {
    path:    "/indicadores/metamembresia/:idEmpleado",
    element: <Dashboards indicador = "metamembresia"/>,
    type: "public",
  },
  {
    path:    "/indicadores/clientes/:idEmpleado",
    element: <Dashboards indicador = "clientes"/>,
    type: "public",
  },
  {
    path:    "/indicadores/colocacion/:idEmpleado",
    element: <Dashboards indicador = "colocacion"/>,
    type: "public",
  },
  {
    path:    "/indicadores/cartera_generada/:idEmpleado",
    element: <Dashboards indicador = "cartera_generada_pasado"/>,
    type: "public",
  },
  {
    path:    "/indicadores/cartera_vigente/:idEmpleado",
    element: <Dashboards indicador = "cartera_vigente_pasado"/>,
    type: "public",
  },
  {
    path:    "/indicadores/quebranto/:idEmpleado",
    element: <Dashboards indicador = "quebranto"/>,
    type: "public",
  },
  {
    path:    "/indicadores/cobranza/avance_recuperacion",
    element: <CobranzaAvanceRecuperacion />,
    type: "public",
  },
  {
    path:    "/indicadores/cobranza/avance_recuperacion/acumulado",
    element: <CobranzaAcumuladoRecuperacion />,
    type: "public",
  },
  {
    path: "/pomelo/consultar/:View/:idEmpleado",
    element: <Pomelo />,
    type: "public"
  },
  {
    path:    "/indicadores/rankings/:idEmpleado",
    element: <Rankings view={"Colocacion"}/>,
    type:"public"
  },
  {
    path:    "/indicadores/comparativos/:idEmpleado",
    element: <Comparativos />,
    type:"public"
  },
  {
    path:    "/indicadores/zonificacion/:idEmpleado",
    element: <ZonificacionMap/>,
    type: "public",
  },
  {
    path:    "/indicadores/zonificacion/:idEmpleado/:puesto/:typeView",
    element: <Zonificacion/>,
    type: "public",
  },
  {
    path:    "/indicadores/cartera_buckets/:idEmpleado",
    element: <DashCarteraBuckets/>,
    type: "public",
  },
  {
    path: "/validacion-cliente",
    element: <ValidacionCliente />,
    type: "public"
  },
  {
    path: '/ordenes-pago',
    element: <OrdenesPago />,
    type: 'public'
  },
  {
    path: '/expedientes',
    element: <Expedientes />,
    type: 'public'
  },
  {
    path: '/login',
    element: <Login />,
    type: 'public'
  },
  {
    path: '/logout',
    element: <Logout />,
    type: 'public'
  },
  {
    path: '/sam',
    element: <MainContainer />,
    type: 'private'
  },
  {
    path: '*',
    element: <PageNotFound />,
    type: 'public'
  }
];
export default AppRoutes;